import { forwardRef as e, createContext as t } from "react";
import { withContainer as r } from "@kickstartds/core/lib/container";
import o from "@babel/runtime/helpers/esm/defineProperty";
import n from "@babel/runtime/helpers/esm/objectWithoutProperties";
import c from "classnames";
import { defaultRenderFn as i } from "@kickstartds/core/lib/core";
import { RichText as s, defaultRenderFn as m } from "../rich-text/index.js";
import { Button as a } from "../button/index.js";
import { Picture as p } from "../picture/index.js";
import { jsxs as l, jsx as b } from "react/jsx-runtime";
import "./content-box.css";
import "react-markdown";
import "../rich-text/rich-text.css";
import "../link/index.js";
import "../icon/index.js";
import "../icon/icon.css";
import "../button/button.css";
const d = ["image", "topic", "alignement", "text", "link", "ratio", "renderTopic", "renderText", "className", "component"];
function x(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, o);
  }
  return r;
}
function f(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {};
    t % 2 ? x(Object(r), !0).forEach(function (t) {
      o(e, t, r[t]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : x(Object(r)).forEach(function (t) {
      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    });
  }
  return e;
}
const u = e((e, t) => {
  let {
      image: r,
      topic: o,
      alignement: x = "left",
      text: u,
      link: j,
      ratio: h = "none",
      renderTopic: O = i,
      renderText: g = m,
      className: _,
      component: y
    } = e,
    k = n(e, d);
  return l("div", f(f({
    className: c("c-content-box", x && "left" !== x && `c-content-box--align-${x}`, _),
    "ks-component": y,
    ref: t
  }, k), {}, {
    children: [r && b("div", {
      className: c("c-content-box__image", {
        "c-content-box__image--four-to-three": "4:3" === h,
        "c-content-box__image--sixteen-to-nine": "16:9" === h,
        "c-content-box__image--square": "1:1" === h
      }),
      children: b(p, {
        src: r,
        alt: ""
      })
    }), l("div", {
      className: "c-content-box__body",
      children: [l("div", {
        className: "c-content-box__text",
        children: [o && b("p", {
          className: "c-content-box__topic",
          children: O(o)
        }), u && b(s, {
          text: u,
          renderText: g
        })]
      }), j && j.enabled && b("div", {
        className: "c-content-box__link",
        children: b(a, f({}, f(f({}, j), {}, {
          enabled: void 0
        })))
      })]
    })]
  }));
});
const j = t(u);
const h = r("content-box", j);
export { h as ContentBox, j as ContentBoxContext, u as ContentBoxContextDefault };